// const onLocalHost = window.location.host.search('localhost') === 0;
//const baseUrl = onLocalHost ? "http://daftest.local/cmsapi/v1.0" : `${window.location.origin}/cmsapi/v1.0`.replace(`//cms`,`//daf`);
// const baseUrl = onLocalHost ? "https://daftest.deroostermakers.net/cmsapi/v1.0" : `${window.location.origin}/cmsapi/v1.0`.replace(`//cms`,`//daf`);

let apiConfig = {
  baseUrl: window.drm.baseUrl,
  maxErrorLogLength: 1000,
  reloginTimeout: 5000,
  scenarioTemplatePlanPollInterval: 10000,
  watchDogIntervalHttp: 5 * 60 * 1000,
  error: {
    NO_CREDENTIALS: 'No credentials.',
    LOGIN_ERROR: 'Login error.',
    SYSTEM_INFO_ERROR: 'System info error.',
    SCENARIO_TEMPLATE_PLAN_ERROR: 'Scenario template plan error.',
    ARTICLE_LIST_ERROR: 'Article list error.',
    ARTICLE_ERROR: 'Article error.',
    TEMPLATE_ERROR: 'Template error',
    RECEIVED_INCORRECT_DATA_FORMAT: 'Received incorrect data format',
    SERVICE_PROCESSING_ERROR: 'Service processing error'
  },
  errorLevel: {
    BLOCKING: 'BLOCKING',
    WARNING: 'WARNING'
  },
  message: {
    ARTICLES_SCHEDULED: 'Articles scheduled.',
    NO_CURRENT_WEEK_SCENARIO: 'No current week scenario.'
  }
};
export default apiConfig;



// WEBPACK FOOTER //
// ./client/app/services/apiconfig.js